import type { Registry as Services } from '@ember/service';
import { formatDate } from 'uplisting-frontend/helpers/date-format';

export const HOMEAWAY_CONTENT_ISSUE_DATE_FORMAT = 'd MMM yyyy, HH:mm';

const FALLBACK_KEY = 'other';

export function homeawayContentIssueKey(
  intl: Services['intl'],
  baseKey: string,
  value: string | null,
): string {
  const key = `${baseKey}.${value}`;

  return value && intl.exists(key) ? key : `${baseKey}.${FALLBACK_KEY}`;
}

export function formatHomeawayContentIssueTime(at: string | null): string {
  return at ? formatDate(at, HOMEAWAY_CONTENT_ISSUE_DATE_FORMAT) : '';
}
